import { createAsyncThunk } from '@reduxjs/toolkit';
import purchaseOrdersApi from '../../../api/purchaseOrdersApi';
import rawMaterialInventoryApi from '../../../api/rawMaterialInventoryApi';
import rawMaterialTemplateApi from '../../../api/rawMaterialTemplateApi';
import roomsApi from '../../../api/roomsApi';
import { PURCHASE_ORDER_TYPES } from '../../../sections/@dashboard/purchaseOrders/AddEditForm/constants';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'rawMaterialInventory';

export const GetRawMaterialInventoryItem = createAsyncThunk(
  `${REDUCER_NAME}/getRawMaterialInventoryItem`,
  async (id, thunkAPI) => {
    const res = await rawMaterialInventoryApi.getById(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetRawMaterialInventory = createAsyncThunk<any, { inactive?: boolean }>(
  `${REDUCER_NAME}/getRawMaterialInventory`,
  async (data, thunkAPI) => {
    const res = await rawMaterialInventoryApi.get(data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateRawMaterialInventoryItem = createAsyncThunk<any, { data: any; id: string }>(
  `${REDUCER_NAME}/updateRawMaterialInventoryItem`,
  async ({ data, id }, thunkAPI) => {
    const res = await rawMaterialInventoryApi.update(id, data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const CreateRawMaterialInventoryItem = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/createRawMaterialInventoryItem`,
  async (data, thunkAPI) => {
    const res: any = await rawMaterialInventoryApi.create(data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const RemoveRawMaterialInventoryItem = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/removeRawMaterialInventoryItem`,
  async (id, thunkAPI) => {
    const res: any = await rawMaterialInventoryApi.delete(id);

    if (res.status === 200) {
      return {
        ...res.data,
        id,
      };
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const ImportRawMaterials = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/importRawMaterials`,
  async (data, thunkAPI) => {
    const res = await rawMaterialInventoryApi.import(data);

    if (res.status === 200) {
      thunkAPI.dispatch(GetRawMaterialInventory({}));
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const ReceiveRawMaterials = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/receiveRawMaterials`,
  async (data, thunkAPI) => {
    const res = await rawMaterialInventoryApi.receive(data);

    if (res.status === 200) {
      thunkAPI.dispatch(GetRawMaterialInventory({}));

      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetRawMaterialsPurchaseOrders = createAsyncThunk(
  `${REDUCER_NAME}/getRawMaterialsPurchaseOrders`,
  async (__, thunkAPI) => {
    const res = await purchaseOrdersApi.get();

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetRawMaterialsPurchaseOrdersForReceive = createAsyncThunk(
  `${REDUCER_NAME}/getRawMaterialsPurchaseOrdersForReceive`,
  async (__, thunkAPI) => {
    const res = await purchaseOrdersApi.getForReceive(PURCHASE_ORDER_TYPES.PACKING_RAW_MATERIAL);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetRawMaterialsTemplates = createAsyncThunk(
  `${REDUCER_NAME}/getRawMaterialsTemplates`,
  async (__, thunkAPI) => {
    const res = await rawMaterialTemplateApi.get();

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetRawMaterialRooms = createAsyncThunk(`${REDUCER_NAME}/getRawMaterialsRooms`, async (__, thunkAPI) => {
  const res = await roomsApi.getRawMaterialInventoryRooms();

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const GetTobaccoRooms = createAsyncThunk(`${REDUCER_NAME}/getTobaccoRooms`, async (__, thunkAPI) => {
  const res = await roomsApi.getTobaccoInventoryRooms();

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const UpdateIsMinimumStockLevelActive = createAsyncThunk<any, { data: any; id: string }>(
  `${REDUCER_NAME}/updateIsMinimumStockLevelActive`,
  async ({ id, data }, thunkAPI) => {
    const res = await rawMaterialTemplateApi.updateIsMinimumStockLevelActive(id, data);

    if (res.status === 200) {
      return { id, data };
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateMinimumStockLevel = createAsyncThunk<any, { data: any; id: string }>(
  `${REDUCER_NAME}/updateMinimumStockLevel`,
  async ({ id, data }, thunkAPI) => {
    const res = await rawMaterialTemplateApi.updateMinimumStockLevel(id, data);

    if (res.status === 200) {
      return { id, data };
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateInactiveRawStatus = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/updateInactiveRawStatus`,
  async (id, thunkAPI) => {
    const res = await rawMaterialTemplateApi.updateInactiveStatus(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetRawMaterialInventoryTemplateById = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/getRawMaterialInventoryTemplateById`,
  async (id, thunkAPI) => {
    const res = await rawMaterialTemplateApi.getById(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateRawMaterialTemplateById = createAsyncThunk<any, { data: any; id: string }>(
  `${REDUCER_NAME}/updateRawMaterialTemplateById`,
  async ({ data, id }, thunkAPI) => {
    const res = await rawMaterialTemplateApi.updateById(id, data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);
